"use client";
import { Button } from "@/components";
import { getImageURL } from "@/lib";
export const PrimePageDownloadCenter = ({ data = {}, slug = "download" }) => {
    const { heading, image, document, bg_image, list = [] } = data;

    const getLinkProps = (link) => {
        if (!link?.url) return {};
        let props = { href: link.url };
        if (link.open_new_tab === "yes") {
            props.target = "_blank";
            props.rel = "noopener noreferrer";
        }
        return props;
    };

    return (
        <>
            <section className="download__wp_section">
                <div className="custom-container">
                    <div
                        className="download__wp_inner img-fluid bg_img"
                        style={{
                            backgroundImage: `url(${getImageURL(
                                bg_image?.src,
                            )})`,
                            backgroundSize: "cover",
                            backgroundPosition: "50% 50%",
                            backgroundRepeat: "no-repeat",
                        }}
                    >
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-12 col-lg-11 col-xl-10">
                                <div className="row top__row align-items-center">
                                    <div className="col-12 col-lg-6">
                                        <div className="section_header">
                                            <h3
                                                className="heading fs-48 fw-300 text-white"
                                                dangerouslySetInnerHTML={{
                                                    __html: heading,
                                                }}
                                            />
                                        </div>
                                        <div className="social_media_btn_inr sm-btn-group d-flex">
                                            <div className="google_app_icon">
                                                <a
                                                    className="app_btn d-inline-flex"
                                                    {...getLinkProps(
                                                        list[0]?.link,
                                                    )}
                                                >
                                                    <div className="icon_wrap">
                                                        <img
                                                            className="img-fluid"
                                                            src={getImageURL(
                                                                list[0]?.icon
                                                                    ?.src,
                                                            )}
                                                            alt={
                                                                list[0]?.icon
                                                                    ?.alt
                                                            }
                                                        />
                                                    </div>
                                                    <div className="icon_content content_wrap">
                                                        <div className="btn_sm_text">
                                                            Get it on
                                                        </div>
                                                        <div className="btn_content fs-28 fw-400">
                                                            Google Play
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="app_store_icon">
                                                <a
                                                    className="app_btn d-inline-flex"
                                                    {...getLinkProps(
                                                        list[1]?.link,
                                                    )}
                                                >
                                                    <div className="icon_wrap">
                                                        <img
                                                            src={getImageURL(
                                                                list[1]?.icon
                                                                    ?.src,
                                                            )}
                                                            alt={
                                                                list[1]?.icon
                                                                    ?.alt
                                                            }
                                                        />
                                                    </div>
                                                    <div className="icon_content content_wrap">
                                                        <div className="btn_sm_text">
                                                            Download on
                                                        </div>
                                                        <div className="btn_content fs-28 fw-400">
                                                            App Store
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="img__wrapper">
                                            <img
                                                className="img-fluid"
                                                src={getImageURL(image?.src)}
                                                alt={image?.alt || heading?.replace(/<[^>]*>/g, "") || "Download Waaree App"}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="btn-group text-center">
                        {document?.url ? (
                            <Button
                                label={document?.title}
                                as="a"
                                href={document.url}
                                target={
                                    document.open_new_tab === "yes"
                                        ? "_blank"
                                        : undefined
                                }
                                rel={
                                    document.open_new_tab === "yes"
                                        ? "noopener noreferrer"
                                        : undefined
                                }
                            />
                        ) : null}
                    </div>
                </div>
            </section>
        </>
    );
};
